/**
 * Hero CTA env (Wave H1) — the NEXT_PUBLIC knobs, read ONCE here.
 *
 * No 'use client' directive ON PURPOSE: the marketing pages that gate the
 * hero (`app/for-teams/page.tsx`, `app/for-dev-teams/page.tsx`) are Server
 * Components, and a constant imported from a client module arrives there as
 * a client-reference proxy (always truthy), not the boolean. A plain module
 * is importable from both sides; every `process.env.NEXT_PUBLIC_*` below is
 * a literal reference, so Next inlines it at build on both.
 */

import { readHeroCtaPct } from '@/lib/onboarding/hero-cta';

/** `NEXT_PUBLIC_ONBOARDING_CALL_ENABLED=true` — the call arm can render. */
export const HERO_CTA_CALL_ENABLED =
  (process.env.NEXT_PUBLIC_ONBOARDING_CALL_ENABLED ?? '').toLowerCase() === 'true';

/** E.164 SMS number the composer answers ('' = no SMS path). */
export const HERO_CTA_SMS_NUMBER = (process.env.NEXT_PUBLIC_ONBOARDING_SMS_NUMBER ?? '').trim();

/** E.164 WhatsApp number whose WABA is live ('' = no WhatsApp path). */
export const HERO_CTA_WA_NUMBER = (process.env.NEXT_PUBLIC_ONBOARDING_WHATSAPP_NUMBER ?? '').trim();

/** 0–100 share of visitors on the message arm; unset/0 = call-first. */
export const HERO_CTA_MESSAGE_PCT = readHeroCtaPct(process.env.NEXT_PUBLIC_ONBOARDING_CTA_MESSAGE_PCT);

export const HERO_CTA_HAS_MESSAGE_NUMBER = !!(HERO_CTA_SMS_NUMBER || HERO_CTA_WA_NUMBER);

/** The hero CTA exists when ANY arm can render — the page-level gates
 *  (RoutinesHero, CTASection, /for-teams, /for-dev-teams, TrendSection) use
 *  this instead of the call flag alone, so a message-only hero is possible
 *  and killing the call flag alone no longer removes the CTA. */
export const HERO_CTA_ENABLED = HERO_CTA_CALL_ENABLED || HERO_CTA_HAS_MESSAGE_NUMBER;
